export const meterInYardConversion = 1.09361;
export const kilometerInMileConversion = 0.621371;
export const kilogramToPoundConversion = 2.20462;
